/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { CatalogItemsAmount } from './CatalogItemsAmount'
import {
  CatalogItemsAmountFromJSON,
  CatalogItemsAmountFromJSONTyped,
  CatalogItemsAmountToJSON,
} from './CatalogItemsAmount'

/**
 *
 * @export
 * @interface EnvelopedCatalogItemsAmountSlugListItemsAmount
 */
export interface EnvelopedCatalogItemsAmountSlugListItemsAmount {
  /**
   *
   * @type {CatalogItemsAmount}
   * @memberof EnvelopedCatalogItemsAmountSlugListItemsAmount
   */
  body: CatalogItemsAmount
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCatalogItemsAmountSlugListItemsAmount
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCatalogItemsAmountSlugListItemsAmount interface.
 */
export function instanceOfEnvelopedCatalogItemsAmountSlugListItemsAmount(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCatalogItemsAmountSlugListItemsAmountFromJSON(
  json: any,
): EnvelopedCatalogItemsAmountSlugListItemsAmount {
  return EnvelopedCatalogItemsAmountSlugListItemsAmountFromJSONTyped(json, false)
}

export function EnvelopedCatalogItemsAmountSlugListItemsAmountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCatalogItemsAmountSlugListItemsAmount {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: CatalogItemsAmountFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCatalogItemsAmountSlugListItemsAmountToJSON(
  value?: EnvelopedCatalogItemsAmountSlugListItemsAmount | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: CatalogItemsAmountToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
